import {
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { updateThemeConfig } from "../../actions";
import { formatName } from "./ThemeConfig";
import { Box, Grid } from "@mui/material";

function RadioComponent({ ...props }) {
  const dispatch = useDispatch();
  return (
    <Box sx={{padding:'15px 0 !important'}}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
           <FormControlLabel
              control={
                <Checkbox  />
              }
              label={formatName(props.field.name)}
              style={{margin:0, justifyContent:"space-between", width:'100%'}}
              labelPlacement="start"
              checked={props.field.value === "1"}
              onChange={(e) => {
                let value = e.target.checked ? "1" : "0";
                dispatch(updateThemeConfig(props.field.name, value));
              }}
              name={props.field.name}
            />
        </Grid>
      </Grid> 
    </Box>
  );
}

export default RadioComponent;
